import axiosInstance from '../app/axios';

export const settingsAPI = {
  getPublic: async () => {
    const response = await axiosInstance.get('/settings');
    return response.data;
  },
};

export default settingsAPI;
